import React from "react";
import Navbar from "../components/Navbar";
import CarCard from "../components/CarCard";
import cars from "../data/cars";
import Footer from "../components/Footer";
import VehicleMarquee from "../components/VehicleMarquee";
import QuickLinks from "../components/QuickLinks";

function Landing() {
  return (
    <div>
      

      {/* HERO */}
      <div className="hero">
        <div className="container">
          <h1>Find Your Dream Car</h1>
          <p>Best cars at the best prices</p>
        </div>
      </div>

      {/* CAR LIST */}
      <div className="container my-4">
        <div className="row">
          {cars.map((car) => (
            <div key={car.id} className="col-lg-3 col-md-4 col-sm-6 mb-4">
              <CarCard car={car} />
            </div>
          ))}
        </div>
        <QuickLinks />
      </div>
      

      <VehicleMarquee />

      <Footer />
    </div>
  );
}

export default Landing;